// Components==============
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import CircleButton from 'components/UI/CircleButton/CircleButton';
import EvidenceCard from 'components/UI/EvidenceCard/EvidenceCard';
import React, { useContext } from 'react';
import { EvidenceGroupType } from 'typings';
import { MyWorkContext } from '../../MyWork';
import './EvidenceGroup.module.scss';
// =========================

export default function EvidenceGroup({
  evidenceGroup,
}: {
  evidenceGroup: EvidenceGroupType;
}) {
  const {
    setSelectedEvidenceIds,
    setAddModalIsOpen,
    assessedEvidenceIds,
  } = useContext(MyWorkContext);

  function handleAddModalClick(id: number) {
    setAddModalIsOpen(true);
    setSelectedEvidenceIds([id]);
  }
  return (
    <div styleName="wrapper">
      <div styleName="title">
        <h2>{evidenceGroup.title}</h2>
        <CircleButton
          color="grey-blue"
          small
          icon={faPlus}
          onClick={() => {
            setAddModalIsOpen(true);
            setSelectedEvidenceIds(
              evidenceGroup.evidence.map((e) => e.evidence.id)
            );
          }}
        />
      </div>
      <div styleName="evidence">
        {evidenceGroup.evidence.map((e, i) => (
          <EvidenceCard
            key={i}
            evidence={e.evidence}
            isAssessed={
              e.evidence.process_type === 'App\\ProjectProcess' &&
              assessedEvidenceIds.includes(e.evidence.process_id)
            }
            handleAddModalClick={() => handleAddModalClick(e.evidence.id)}
          />
        ))}
      </div>
    </div>
  );
}
